import { render, staticRenderFns } from "./TheFileAttachmentsDisplay.vue?vue&type=template&id=3c5dd736&scoped=true"
import script from "./TheFileAttachmentsDisplay.vue?vue&type=script&lang=js"
export * from "./TheFileAttachmentsDisplay.vue?vue&type=script&lang=js"
import style0 from "./TheFileAttachmentsDisplay.vue?vue&type=style&index=0&id=3c5dd736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5dd736",
  null
  
)

export default component.exports